import { EnvirotainerContainerStatus } from "./EnvirotainerContainerStatus";

export enum SortBy {
	UPDATED_AT,
	DEVICE_ID,
	MASTER_TRACKING_NO,
}

export const sortByMap: Map<SortBy, { displayName: string; fieldName: string }> = new Map([
	[SortBy.UPDATED_AT, { displayName: "Updated At", fieldName: "UpdatedAt" }],
	[SortBy.DEVICE_ID, { displayName: "Container Id", fieldName: "DeviceId" }],
	[SortBy.MASTER_TRACKING_NO, { displayName: "Order Id", fieldName: "MasterTrackingNo" }],
]);

export const sortOptions = (filter?: EnvirotainerContainerStatus) => Object.keys(SortBy)
	.map(key => ({
		value: SortBy[key],
		label: sortByMap.get(SortBy[key])?.displayName,
		isDisabled: SortBy[key] === SortBy.UPDATED_AT && filter === EnvirotainerContainerStatus.ALLOCATED,
	}))
	.filter(option => !!option.label);
